import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { chipLogs } from "../../../../../store/slices/APIResponseSlice";
import AirHomeLoader from "../../../../../components/Common/AirHomeLoader";
import { RefreshBtn } from "../../../../../components/Common/button";
import Request from "../../../../../helpers/request";
import getStorageData from "../../../../../Utils/getStorageData";
interface InterfaceDataTable {
  apiURL: string;
  title?: string;
  isReload?: boolean;
  columns: any[];
  selectedRoomID?: any[];
  ExpandedComponent?: any;
  customStyles: any;
  ExpandCollapseIcon: any;
  idName: string;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  selectedRows: any;
  setSelectedRows: any;
  handlePingAll?: () => void;
  handleDsAll?: () => void;
  handleUpdateWifiAll?: () => void;
  handleDeleteAll?: () => void;
  handleOtaAll?: () => void;
  handleBSCHAll?: () => void;
  handleBinding?: () => void;
  handleUU?: () => void;
  userId: any;
  selectedPremise?: any;
  expandableRows: boolean;
  setChipData?: any;
  showBindingButton?: any;
  actionButton?:any;
}

function ChipsDataTable({
  userId,
  selectedPremise,
  apiURL,
  expandableRows,
  title,
  selectedRoomID,
  isReload,
  columns,
  ExpandedComponent,
  customStyles,
  ExpandCollapseIcon,
  idName,
  loading,
  setLoading,
  selectedRows,
  setSelectedRows,
  handlePingAll,
  handleDsAll,
  handleUpdateWifiAll,
  handleDeleteAll,
  handleOtaAll,
  handleBSCHAll,
  handleBinding,
  handleUU,
  setChipData,
  showBindingButton,
  actionButton,
}: InterfaceDataTable) {
  const dispatch = useDispatch();
  const userDetails = getStorageData()?.user;
  const allowedUserIds = [
    "67f5f80adf5b24d780bfd24c",
    "67beb885cd36b805b571cc2d",
    "66e55cbba53f0003767e4b29",
    "6957b435a2a46e17edea011d",
  ];
  const isUserAllowed = allowedUserIds.includes(userDetails?.id || "");

  const [data, setData] = useState<any[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const isFetchingRef = useRef<boolean>(false);
  const [responseMsg, setResponseMsg] = useState<string>("");
  const [firmwareStatus, setFirmwareStatus] = useState<string>("");
  const fetchData = async (
    page: number,
    perPage: number,
    searchValue: string,
  ) => {
    setLoading(true);
    if (isFetchingRef.current) {
      return;
    }
    isFetchingRef.current = true;

    try {
      const reqObj = {
        draw: 1,
        order: [],
        start: (page - 1) * perPage,
        length: perPage,
        search: {
          value: searchValue,
          regex: false,
        },
        ...(idName === "Driverlist" && { type: "airDriver" }),
        userId: userId,
        ...(selectedPremise ? { premiseId: selectedPremise.id } : {}),
        roomId:
          selectedRoomID
            ?.filter((item: any) => item.isChecked)
            .map((item: any) => item.id)
            .join(",") || "",
      };

      const response = await Request.post(apiURL, reqObj);
      setResponseMsg(response.data?.msg || "");
      setFirmwareStatus(response.data?.firmwareSummary?.status || "");
      setData(response.data.data || []);
      setTotalRows(response.data.recordsTotal || 0);
      if (idName === "Chiplist") {
        setChipData(response.data.data || []);
      }

      if (idName === "Chiplist" || idName === "Blasterlist") {
        dispatch(
          chipLogs({
            totalOfflineTime: response.data?.totalOfflineTime,
            totalOnlineTime: response.data?.totalOnlineTime,
          }),
        );
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        // window.localStorage.clear();
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      }
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  useEffect(() => {
    fetchData(page, perPage, searchText);
  }, [page, perPage, searchText, apiURL, selectedRoomID, isReload]);

  const handlePageChange = (newPage: number) => setPage(newPage);

  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  const handleSelectedRowsChange = ({
    selectedRows,
  }: {
    selectedRows: any[];
  }) => {
    setSelectedRows(selectedRows);
  };
  const handleReload = () => {
    fetchData(page, perPage, searchText);
  };
  return (
    <Card>
      <CardBody>
        <div className="">
          <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            highlightOnHover
            customStyles={customStyles}
            selectableRows
            onSelectedRowsChange={handleSelectedRowsChange}
            {...(expandableRows && {
              expandableRows: true,
              expandableRowsComponent: ExpandedComponent,
              expandableIcon: {
                collapsed: <ExpandCollapseIcon expanded={false} />,
                expanded: <ExpandCollapseIcon expanded={true} />,
              },
            })}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            subHeader
            subHeaderComponent={
              <div className="container-fluid p-0 pb-2">
                <div className="row gx-2 gy-2 align-items-center">
                  <div className="col-12 col-md-6 d-flex  align-items-center gap-2"  >
                    <h5 className="m-0 fw-bold text-start" style={{ fontSize: "18px" }}>
                      {title || "Data Table"}
                    </h5>
                 {idName === "Gatewaylist" && responseMsg && (
                    <div className="d-flex flex-nowrap align-items-center gap-2 ms-2 py-1">

                      {/* Firmware Message */}
                      <div
                        className="px-3 py-1 rounded fw-semibold text-nowrap"
                        style={{
                          fontSize: "13px",
                          color: firmwareStatus === "all_ok" ? "#198754" : "#dc2626",
                          backgroundColor:
                            firmwareStatus === "all_ok" ? "#d1e7dd" : "#f8d7da",
                          border: `1px solid ${
                            firmwareStatus === "all_ok" ? "#a3cfbb" : "#f1aeb5"
                          }`,
                        }}
                      >
                        {responseMsg}
                      </div>

                      {/* Dimmable + Tunable */}
                      <div
                        className="d-flex align-items-center gap-2 px-3 py-2 rounded text-nowrap"
                        style={{ backgroundColor: "#fce7f3" }}
                      >
                        <span
                          style={{
                            width: 9,
                            height: 9,
                            borderRadius: "50%",
                            backgroundColor: "#a855f7",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        <span className="fw-semibold" style={{ fontSize: "12px" }}>
                          Dimmable + Tunable
                        </span>
                      </div>

                      {/* Dimmable Only */}
                      <div
                        className="d-flex align-items-center gap-2 px-3 py-2 rounded text-nowrap"
                        style={{ backgroundColor: "#fff7e6" }}
                      >
                        <span
                          style={{
                            width: 9,
                            height: 9,
                            borderRadius: "50%",
                            backgroundColor: "#f59e0b",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        <span className="fw-semibold" style={{ fontSize: "12px" }}>
                          Dimmable Only
                        </span>
                      </div>

                      {/* Group */}
                      <div
                        className="d-flex align-items-center gap-2 px-3 py-2 rounded text-nowrap"
                        style={{ backgroundColor: "#f3f4f6" }}
                      >
                        <span
                          style={{
                            width: 9,
                            height: 9,
                            borderRadius: "50%",
                            backgroundColor: "#9ca3af",
                            display: "inline-block",
                            flexShrink: 0,
                          }}
                        />
                        <span className="fw-semibold" style={{ fontSize: "12px" }}>
                          Group
                        </span>
                      </div>

                    </div>
                  )}
      
                    {selectedRows.length > 0 && (
                      <div
                        className="fw-bold text-dark bg-light px-2 py-1 rounded fade show"
                        style={{
                          fontSize: "12px",
                          transition: "opacity 0.3s ease-in-out",
                          lineHeight: "1.2",
                        }}
                      >
                        {selectedRows.length}{" "}
                        {selectedRows.length === 1 ? "item" : "items"} selected
                      </div>
                    )}
                    {showBindingButton && idName === "Chiplist" && (
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleBinding && handleBinding()}
                      >
                        Device Binding
                      </button>
                    )}
                     {actionButton && (
                        <div className="ms-2">
                          {actionButton}
                        </div>
                      )}
                  </div>

                  {/* Search and Action Buttons */}
                  <div className="col-12 col-md-6 d-flex flex-wrap justify-content-md-end align-items-center gap-2">
                    {/* Search Input */}

                    {(idName === "Chiplist" ||
                      idName === "Curtainlist" ||
                      idName === "Blasterlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => handleOtaAll && handleOtaAll()}
                        >
                          OTA
                        </button>
                      )}
                    {isUserAllowed &&
                      (idName === "Chiplist" || idName === "Curtainlist" || idName === "Gatewaylist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() =>
                            handleUpdateWifiAll && handleUpdateWifiAll()
                          }
                        >
                          UPDATE WiFi
                        </button>
                      )}
                    {(idName === "Chiplist" ||
                      idName === "Blasterlist" ||
                      idName === "Locklist" ||
                      idName === "Driverlist" ||
                      idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => handleDeleteAll && handleDeleteAll()}
                        >
                          Delete
                        </button>
                      )}

                    {(idName === "Chiplist" || idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => handleDsAll && handleDsAll()}
                        >
                          DS
                        </button>
                      )}
                    {(idName === "Chiplist" || idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => handlePingAll && handlePingAll()}
                        >
                          Ping
                        </button>
                      )}
                    {idName === "Blasterlist" && selectedRows.length > 0 && (
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleBSCHAll && handleBSCHAll()}
                      >
                        BSCH
                      </button>
                    )}
                    {idName === "Gatewaylist" &&  selectedRows.length > 0 && (
                      <button className="btn btn-outline-dark btn-sm" onClick={handleUU}>
                        UU
                      </button>
                    )}
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control form-control-sm"
                      style={{ maxWidth: "150px" }}
                      value={searchText}
                      onChange={handleSearch}
                    />
                    <RefreshBtn onClick={handleReload} loading={loading} />
                  </div>
                </div>
              </div>
            }
          />
        </div>
        {loading && <AirHomeLoader />}
      </CardBody>
    </Card>
  );
}

export default ChipsDataTable;
